var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.6,30.8l3.8,3.7c-2.9,2.2-5.4,5-9.7,5c0.1,0,0.1-10.8,0-18.1h3.4v-2h-3.4c0-1.5,0-2.8,0-3.6c3.3-1.1,5.7-4.1,5.7-7.7c0-4.5-3.8-8.2-8.4-8.2c-4.7,0-8.4,3.7-8.4,8.2c0,3.5,2.3,6.5,5.6,7.7v3.6h-3.4v2h3.4l0,18c-4.5,0-7.1-2.5-9.9-4.7l4.1-3.9L1.6,28.6l2.2,14.3l3.9-3.8c3.2,2.6,7.4,6.1,15.6,6.5l0.7,4.4h1.7l0.7-4.4c8-0.4,12.1-4,15.3-6.7l4.3,4.2l2.1-14.4L33.6,30.8z M20.7,8.1c0-2.3,1.9-4.2,4.3-4.2s4.3,1.9,4.3,4.2c0,2.3-1.9,4.2-4.3,4.2C22.7,12.3,20.7,10.4,20.7,8.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarine);
export default __webpack_public_path__ + "static/media/marine.2624b810da2ad7695e1062a8a7b8b47d.svg";
export { ForwardRef as ReactComponent };